export const SEEK_VIDEO = 'SEEK_VIDEO';
export const SET_VISIBLE_STREAMS = 'SET_VISIBLE_STREAMS';
export const TOGGLE_PTZ_MENU = 'TOGGLE_PTZ_MENU';
export const VIDEO_INIT = 'VIDEO_INIT';
export const TOGGLE_VIDEO = 'TOGGLE_VIDEO';
export const PLAY_VIDEO = 'PLAY_VIDEO';
export const PAUSE_VIDEO = 'PAUSE_VIDEO';
export const SET_VIDEO_SPEED = 'SET_VIDEO_SPEED';
export const SET_LAYOUT = 'SET_LAYOUT';
export const SET_SETTINGS_MENU_STATE = 'SET_SETTINGS_MENU_STATE';
export const SET_VOLUME = 'SET_VOLUME';
export const SET_MUTE = 'SET_MUTE';
export const SET_DIRECT_STREAM_INFO = 'SET_DIRECT_STREAM_INFO';

// background color of the video player
export const VIDEO_BACKGROUND_COLOR = '#131313';

export const SUBSCRIBE_VIDEO_STATE_CHANGE = 'SUBSCRIBE_VIDEO_STATE_CHANGE';
export const UN_SUBSCRIBE_VIDEO_STATE_CHANGE = 'UN_SUBSCRIBE_VIDEO_STATE_CHANGE';
export const DISPOSE_VIEWER_STORE = 'DISPOSE_VIEWER_STORE';

export const TOGGLE_SIM_GRAPH = 'TOGGLE_SIM_GRAPH';
export const UPDATE_VIDEO_ORDER = 'UPDATE_VIDEO_ORDER';
export const UPDATE_OFF_FEEDS = 'UPDATE_OFF_FEEDS';
